(ns practitest.frontend.common-old-fe.utils
  (:require
    [clojure.pprint :refer [cl-format]]
    [clojure.string :as string]))

(defn valid-duration? [s]
  (boolean (re-matches #"^\d{1,2}:\d{1,2}:\d{1,2}$" s)))

(defn format-duration [duration]
  (if duration
    (cl-format nil "~2,'0d:~2,'0d:~2,'0d"
               (.hours duration)
               (.minutes duration)
               (.seconds duration))
    "00:00:00"))

(defn parse-duration [s]
  (if (string/includes? s ":")
    (let [[hours minutes seconds] (string/split (or s "00:00:00") #":" 3)]
      (js/moment.duration
        (+ (js/parseInt seconds)
           (* 60 (js/parseInt minutes))
           (* 3600 (js/parseInt hours)))
        "seconds"))
    (js/moment.duration (js/parseInt s) "seconds")))

(defn parse-duration* [s]
  (if (valid-duration? s)
    (parse-duration s)
    (let [parts (re-seq #"\d+\s?(?:[s|m|h]\w*)?" s)]
      (reduce (fn [duration part]
                (let [[_ n u] (re-find #"^(\d+)\s*([s|m|h])?.*$" part)]
                  (if n
                    (.add duration (js/moment.duration (js/parseInt n) (or u "s")))
                    duration)))
              (js/moment.duration)
              parts))))

(defn parse-auto-filter-id [raw-id]
  (let [[_ id v] (re-find #"(\d+)(?:-(.*))?$" raw-id)]
    [id v]))
